import React, { Component } from 'react';
import ARROW_BLUE from 'assets/img/play_arrow_blue.svg';
import ARROW from 'assets/img/play_arrow.svg';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ScrollableAnchor from 'react-scrollable-anchor';
import actions from '../../duck/actions';
import LOGO from './img/logo.svg';
import DEVICE from './img/device.png';
import LINE from './img/line.png';
import './style.scss';
import { CustomIcon, Modal } from '../../common';
import Form from './Form';
// import YouTube from 'react-youtube';

const IconWithText = ({ text }) => (
  <div className="landing_cell">
    <img
      style={{
        top: '10px',
        position: 'relative',
        width: '9px',
        height: '9px',
        transform: 'rotate(-90deg)',
      }}
      src={ARROW_BLUE}
      alt=""
    />
    <p>{text}</p>
  </div>
);

class Landing extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    document.body.className = '';
    props.switchTheme(false);
  }

  openGetStarted = () => {
    this.getStarted.open();
  };

  closeGetStarted = () => {
    this.getStarted.close();
  };

  render() {
    const whyParticipateArgs = [
      'Showcase your presence at locations to increase exposure for all services you sell',
      'Your brand representing the technology and locations you service',
      'No cost for providers to participate',
      'Great exposure to buyers and advisors of technology',
    ];
    return (
      <div className="landing">
        <div className="landing_wrapper">
          <header className="landing_header">
            <div className="landing_header_logo">
              <div className="landing_header_logo_row">
                <img src={LOGO} alt="logo" />
              </div>
              <div className="landing_header_subline">Powered by MasterStream</div>
            </div>
            <div className="landing_header_nav">
              <a href="#provider">
                <div className="toggleMode">
                  <CustomIcon width="9px" height="9px" src={ARROW} rotate={-90} />
                  <p>Provider Participation</p>
                </div>
              </a>
              <a
                style={{
                  color: 'white',
                  fontSize: '16px',
                }}
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.masterstreamerp.com/"
              >MasterStream
              </a>
              <button type="button" onClick={() => this.props.history.push('/welcome')}>Login</button>
            </div>
          </header>
          <div className="landing_video">
            <h1>Intelligent Solutions For Every Location</h1>
            <div className="landing_video_wrapper">
              <iframe title="BandwidthFinder Launch Trailer" width="100%" height="100%" src="https://www.youtube.com/embed/8JDogoJcKWk" frameBorder="0" allow="accelerometer; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
            </div>
          </div>
          <ScrollableAnchor id="notify">
            <div className="landing_notify">
              <img src={DEVICE} alt="test" />
              <Form title="BandwidthFinder Takes Off Soon" close={() => { }} />
            </div>
          </ScrollableAnchor>
          <ScrollableAnchor id="provider">
            <div className="landing_provider">
              <h2>Provider Participation</h2>
              <img src={LINE} alt="line" />
              <div className="landing_provider_participate">
                <div className="landing_provider_participate_who">
                  <h3>Who can participate?</h3>
                  <div className="landing_provider_participate_who_wrapper">
                    <div className="landing_provider_participate_cell">
                      <h4>Facilities Based Carriers</h4>
                      <p>Represent your presence at a building as facility owner</p>
                      <IconWithText text="Carriers" />
                      <IconWithText text="Cable Companies" />
                      <IconWithText text="Mobile Carriers" />
                    </div>
                    <div className="landing_provider_participate_cell">
                      <h4>MSPs, Resellers, Providers</h4>
                      <p>Represent your presence at a building as a basis
                        for selling other services
                      </p>
                      <IconWithText text="MSPs" />
                      <IconWithText text="Providers" />
                      <IconWithText text="Resellers" />
                      <IconWithText text="MVNOs" />
                      <IconWithText text="Aggregators" />
                    </div>
                    <div className="landing_provider_participate_cell">
                      <h4>All Technologies Represented</h4>
                      <p>Dedicated, Broadband, Mobile</p>
                      <IconWithText text="Fiber, Fixed Wireless, Cable, LTE, DSL and more…" />
                    </div>
                  </div>
                </div>
                <div className="landing_provider_participate_why">
                  <div className="landing_provider_participate_row">
                    <h3>WHY PARTICIPATE</h3>
                    <button type="button" onClick={this.openGetStarted}>Get Started</button>
                  </div>
                  {whyParticipateArgs.map(
                    argument => <IconWithText key={argument} text={argument} />,
                  )}
                </div>
              </div>
            </div>
          </ScrollableAnchor>
          <footer className="landing_footer">
            <div className="landing_footer_logo">
              <div className="landing_header_logo_row">
                <img src={LOGO} alt="logo" />
              </div>
              <div className="landing_footer_subline">Powered by MasterStream</div>
            </div>
            <div className="landing_footer_row">
              <p>2018 BandwidthFinder.com all rights reserved</p>
              <div className="landing_footer_nav">
                <a href="mailto:bandwidthfinder@mserp.com">Contact</a>
              </div>
            </div>
          </footer>
        </div>
        <Modal ref={(r) => {
          this.getStarted = r;
        }}
        >
          <Form
            isModal
            title="Request to be a part of our Provider Participation Program"
            close={this.closeGetStarted}
          />
        </Modal>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  switchTheme: isDarkTheme => dispatch(actions.switchTheme(isDarkTheme)),
});

export default withRouter(connect(null, mapDispatchToProps)(Landing));



// WEBPACK FOOTER //
// ./src/view/screens/Landing/Landing.jsx